import { render, staticRenderFns } from "./InventoryLabResultForm.vue?vue&type=template&id=9077005a"
import script from "./InventoryLabResultForm.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9077005a')) {
      api.createRecord('9077005a', component.options)
    } else {
      api.reload('9077005a', component.options)
    }
    module.hot.accept("./InventoryLabResultForm.vue?vue&type=template&id=9077005a", function () {
      api.rerender('9077005a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultForm.vue"
export default component.exports